<template>
  <simple-page header="设备日统计明细"
               @query="query"
               @reset="reset">
    <template #buttons>
      <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
    </template>
    <template #form>
      <el-form ref="queryForm" :model="queryForm" inline>
        <el-form-item label="所属单位" prop="compId">
          <comp-select v-model="queryForm.compId" multiple collapse-tags></comp-select>
        </el-form-item>
        <el-form-item label="统计日期" prop="dates">
          <el-date-picker v-model="dates" type="daterange"
                          value-format="yyyy-MM-dd"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </el-form>
    </template>

    <template #formMore>
      <el-form ref="moreForm" :model="queryForm" inline>
        <el-form-item label="设备类型" prop="deviceType">
          <code-select code-type="DEVICE_TYPE" v-model="queryForm.deviceType"></code-select>
        </el-form-item>
        <el-form-item label="设备编号" prop="deviceCode">
          <el-input v-model.trim="queryForm.deviceCode"></el-input>
        </el-form-item>
      </el-form>
    </template>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
        <el-table-column prop="dt" label="日期" min-width="90" align="center"></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" align="center" width="130"></el-table-column>
        <el-table-column prop="device.deviceName" label="设备名称" min-width="120"></el-table-column>
        <el-table-column prop="device.address" label="地址" min-width="150"></el-table-column>
        <el-table-column prop="device.inFanCount" label="新风台数" align="center" width="60"></el-table-column>
        <el-table-column prop="device.deviceTypeName" label="设备类型" align="center" width="60"></el-table-column>
        <el-table-column prop="device.roomTypeName" label="机房类型" align="center" width="60"></el-table-column>
        <el-table-column prop="device.compName" label="所属单位" min-width="130"></el-table-column>
        <el-table-column label="设备通电状态" align="center" min-width="80" v-slot="{row}">
          启用
        </el-table-column>
        <el-table-column label="是否存在故障" align="center" min-width="80" v-slot="{row}">
          <span v-if="row.sensorErrorCount > 0" class="color-error">是</span>
          <span v-else>否</span>
        </el-table-column>
        <el-table-column label="新风运行时长" align="center" min-width="80" v-slot="{row}">
          {{((row.fanRunMinutes || 0) / 60).toFixed(1) || '--' }}
        </el-table-column>
        <el-table-column label="空调运行时长" align="center" min-width="80" v-slot="{row}">
          {{((row.acRunMinutes || 0) / 60).toFixed(1) || '--' }}
        </el-table-column>
        <el-table-column label="室内平均温度1" align="center" min-width="80" v-slot="{row}">
          {{((row.minInTemp || 0) + (row.maxInTemp || 0) / 2).toFixed(0) || '--' }}
        </el-table-column>
        <el-table-column label="室内平均温度2" align="center" min-width="80" v-slot="{row}">
          <span v-if="row.minInTemp2 !== undefined && row.maxInTemp2 !== undefined">
          {{((row.minInTemp2 || 0) + (row.maxInTemp2 || 0) / 2).toFixed(0) || '--' }}
          </span>
          <span v-else>--</span>
        </el-table-column>
        <el-table-column label="室外平均温度" align="center" min-width="80" v-slot="{row}">
          {{((row.minOutTemp || 0) + (row.maxOutTemp || 0) / 2).toFixed(0) || '--' }}
        </el-table-column>
        <el-table-column prop="maxInTemp" label="最高室内温度" align="center" min-width="80"></el-table-column>
        <el-table-column prop="maxOutTemp" label="最高室外温度" align="center" min-width="80"></el-table-column>
        <el-table-column label="室内外温差" align="center" min-width="80" v-slot="{row}">
          {{((row.maxInTemp || 0) - (row.maxOutTemp || 0)) || '--' }}
        </el-table-column>
        <el-table-column label="故障原因" align="center" min-width="80" v-slot="{row}">
          --
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
import CodeSelect from "@/components/base/CodeSelect.vue";
import SessionStore from "@/utils/SessionStore";
import * as querystring from "querystringify";
import SimplePage from "@/components/page/SimplePage.vue";
export default {
  components: {SimplePage, CodeSelect, CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      storeKey: "device-month-info",
      dates: [],
      queryForm: {
        compId: null,
        deviceType: '',
        deviceCode: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  created() {
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 8);
    let endDate = new Date();
    endDate.setTime(endDate.getTime() - 3600 * 1000 * 24);
    this.dates = [startDate.format("yyyy-MM-dd"), endDate.format("yyyy-MM-dd")];
    let params = SessionStore.getObjectAndClear(this.storeKey);
    if(!!params) {
      this.queryForm = params;
    }
    this.query();
  },
  methods: {
    query(){
      if(this.dates.length > 0) {
        this.queryForm.startDate = this.dates[0];
        this.queryForm.endDate = this.dates[1];
      }
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-day-info/all-list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    reset() {
      this.$refs['queryForm'].resetFields();
      this.$refs['moreForm'].resetFields();
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/device-day-info/export-all-list?"+params);
    }
  }
}
</script>

<style scoped>

</style>